import { useDispatch, useSelector } from 'react-redux';

import {
  getTeachers,
  setTeachersAction,
  clearTeachersAction,
  setTeachersDetailsAction,
  clearTeachersDetailsAction,
} from 'features/teachers/redux/slice';

import { UseTeachersState, TeachersApiResponse, TeachersDetailsApiResponse } from './types';

const useMenu = (): UseTeachersState => {
  const dispatch = useDispatch();

  const { teachers, teachersDetails } = useSelector(getTeachers);

  const setTeachers = (receivedTeachers: TeachersApiResponse) => {
    dispatch(setTeachersAction(receivedTeachers));
  };

  const clearTeachers = () => {
    dispatch(clearTeachersAction());
  };

  const setTeachersDetails = (receivedTeachersDetails: TeachersDetailsApiResponse) => {
    dispatch(setTeachersDetailsAction(receivedTeachersDetails));
  };

  const clearTeachersDetails = () => {
    dispatch(clearTeachersDetailsAction());
  };

  return {
    teachers,
    setTeachers,
    clearTeachers,
    teachersDetails,
    setTeachersDetails,
    clearTeachersDetails,
  };
};

export default useMenu;
